const CardViewData = ({ selectedCard }) => {
  return (
    <div className="max-w-md mx-auto  rounded-xl shadow-lg overflow-hidden border border-gray-200">

      {/* Body */}
      <div className="p-6 space-y-4">
        <div className="flex justify-between border-b pb-2">
          <span className="font-semibold text-gray-700">ID:</span>
          <span className="text-gray-800 break-all">{selectedCard?.id}</span>
        </div>

        <div className="flex justify-between border-b pb-2">
          <span className="font-semibold text-gray-700">Tier:</span>
          <span className="text-gray-800">{selectedCard?.tier}</span>
        </div>

        <div className="flex justify-between border-b pb-2">
          <span className="font-semibold text-gray-700">Card Holder:</span>
          <span className="text-gray-800">{selectedCard?.card_holder}</span>
        </div>

        <div className="flex justify-between border-b pb-2">
          <span className="font-semibold text-gray-700">Status:</span>
          <span className={`font-medium ${selectedCard?.status === 1 ? 'text-green-600' : 'text-red-600'}`}>
            {selectedCard?.status === 1 ? "Active" : "Inactive"}
          </span>
        </div>

        <div className="flex justify-between border-b pb-2">
          <span className="font-semibold text-gray-700">Deleted:</span>
          <span className={`font-medium ${selectedCard?.is_deleted ? 'text-red-600' : 'text-green-600'}`}>
            {selectedCard?.is_deleted ? "Yes" : "No"}
          </span>
        </div>

        <div className="flex justify-between border-b pb-2">
          <span className="font-semibold text-gray-700">Created At:</span>
          <span className="text-gray-800">
            {new Date(selectedCard?.created_at).toLocaleString()}
          </span>
        </div>

        <div className="flex justify-between">
          <span className="font-semibold text-gray-700">Updated At:</span>
          <span className="text-gray-800">
            {new Date(selectedCard?.updated_at).toLocaleString()}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CardViewData;
